/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Changes_TitleInputs */

const da_terms_changes_title = /** @type {(inputs: Terms_Changes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringer`)
};

/** @type {(inputs: Terms_Changes_TitleInputs) => LocalizedString} */
const en_terms_changes_title = da_terms_changes_title;

/**

* @param {Terms_Changes_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_changes_title = /** @type {((inputs?: Terms_Changes_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Changes_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_changes_title(inputs)
	return /** @type {LocalizedString} */ ("Ændringer")
});